<span>{{ fieldValue | formatNumber: format }}</span>
